import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoggedInGuard } from '../../authentication/logged-in-guard.service';
import { LoggedOutGuard } from '../../authentication/logged-out-guard.service';
import { AuthService }    from '../../authentication/auth.service';
import {EditprofileComponent} from './profile/editprofile/editprofile.component';
import {ViewprofileComponent} from './profile/viewprofile/viewprofile.component';

const routes: Routes = [
  
 
    
    
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/platform/profile/profile-routing.module.ts